export default {
	props: {
		icon: {
			value: String
		}
	},
	methods: {
		getIconSrc() {
			return require(`./../../../assets/images/icons/${this.icon}.svg`);
		}
	}
};



// WEBPACK FOOTER //
// ./app/components/svg-icon/script.js